const emailRule = {
	required: "아이디를 입력해주세요",
	pattern: {
		value: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
		message: "이메일 형식이 올바르지 않습니다",
	},
};

const phoneRule = {
	required: "휴대폰 번호를 입력해주세요",
	pattern: {
		value: /^01([0|1|6|7|8|9])-?([0-9]{3,4})-?([0-9]{4})$/,
		message: "전화번호 형식이 올바르지 않습니다",
	},
};

const passwordRule = {
	required: "비밀번호를 입력해주세요",
};

const urlRule = {
	pattern: {
		value: /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&\/=]*)$/,
		message: "url 형식이 올바르지 않습니다",
	},
	required: "url을 입력해주세요",
};

const urlRuleOptional = {
	pattern: {
		value: /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&\/=]*)$/,
		message: "url 형식이 올바르지 않습니다",
	},
	required: false,
};

const nameRule = {
	required: "이름을 입력해주세요",
};

const positionRule = {
	required: "직책을 입력해주세요",
};

const nicknameRule = {
	required: "닉네임을 입력해주세요",
	pattern: {
		value: /^[가-힣a-zA-Z]+$/,
		message: "띄어쓰기/특수문자는 입력 불가능합니다.",
	},
};

export {
	emailRule,
	nameRule,
	nicknameRule,
	passwordRule,
	phoneRule,
	positionRule,
	urlRule,
	urlRuleOptional,
};
